import { NationalNumber } from '../countries';
import { getPhoneUtil } from '../getPhoneUtil';

/**
 * Get the national number from a phone number.
 */
export const getNationalNumber = (
  phoneNumber: string | null | undefined
): NationalNumber => {
  if (!phoneNumber) {
    return '';
  }

  try {
    const phoneUtil = getPhoneUtil();
    const parsedNumber = phoneUtil.parse(phoneNumber);
    const nationalNumber = parsedNumber.getNationalNumber();

    return nationalNumber ? (`${nationalNumber}` as NationalNumber) : '';
  } catch {
    return '';
  }
};
